<template>
  <div class="d-flex flex-row-reverse">
    <Button
      id="pdp-watchlist-button"
      style-type="link"
      icon-type="icon-left"
      icon-name="star"
      size="small"
      @click="
        openModal(watchListSurveyId);
        trackButton('watchlist');
      "
    >
      {{ $textDictionary['pdp.add2WatchList'] ?? 'pdp.add2WatchList' }}
    </Button>

    <Button
      id="pdp-comparisonlist-button"
      style-type="link"
      icon-type="no-icon"
      size="small"
      @click="
        openModal(comparisonListSurveyId);
        trackButton('comparisonlist');
      "
    >
      {{
        $textDictionary['pdp.add2ComparisonList'] ?? 'pdp.add2ComparisonList'
      }}
    </Button>
  </div>

  <ModalModule
    v-model="showModal"
    :title="$textDictionary['pdp.add2List.title'] ?? 'pdp.add2List.title'"
    close-icon-text="close"
    :esc-to-close="true"
    :click-to-close="true"
    :is-full-screen="true"
    @close="showModal = false"
    @abort="showModal = false"
  >
    <div id="tf-survey-container"></div>
  </ModalModule>
</template>

<script setup lang="ts">
import { Button, ModalModule } from '@hypercodestudio/basler-components';
import * as typeformCreateWidget from '@typeform/embed';
import '@typeform/embed/build/css/widget.css';

const { $textDictionary, $analytics } = useNuxtApp();
const showModal = ref(false);
const watchListSurveyId = 'OB3FTHPm';
const comparisonListSurveyId = 'SmqhUDPg';

function trackButton(label: string) {
  $analytics?.pushToDataLayer({
    event: 'click_internal',
    action: 'add2list',
    label: label
  });
}

function openModal(formId: string) {
  showModal.value = true;
  if (showModal.value) {
    setTimeout(() => {
      const container = document.querySelector(
        '#tf-survey-container'
      ) as HTMLElement;
      if (container) {
        typeformCreateWidget.createWidget(formId, {
          container: container,
          height: 500,
          width: '100%'
        });
      }
    }, 0);
  }
}
</script>
